<template>
  <div
    id="app"
    :class="{ appPc: isPc, 'pc-model': $route.meta.model === 'pc' }"
  >
    <div class="appContent">
      <keep-alive>
        <router-view
          v-if="$route.meta.keepAlive"
          class="router-transition"
          :isPopup="isPopup"
        ></router-view>
      </keep-alive>
      <router-view
        v-if="!$route.meta.keepAlive"
        class="router-transition"
        :isPopup="isPopup"
      ></router-view>
    </div>
  </div>
</template>
<script>
  import { Toast } from 'vant'
  import setTheme from '@/utils/theme' // 设置主题色

  export default {
    components: {},
    data() {
      return {
        isPopup: false,
        isPc: false,
        transitionName: 'slide-right',
      }
    },
    created() {
      Toast.setDefaultOptions({ duration: 3000 })
      Toast.allowMultiple()
      this.setPopup()
      // 在页面加载时读取sessionStorage
      if (sessionStorage.getItem('store')) {
        this.$store.replaceState({
          ...this.$store.state,
          ...JSON.parse(sessionStorage.getItem('store')),
        })
      }
      // 在页面刷新时将store保存到sessionStorage里
      window.addEventListener('pagehide', () => {
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      })
    },
    watch: {
      $route(to, from) {
        const { isBack } = this.$router
        if (isBack) {
          this.transitionName = 'slide-right'
        } else {
          this.transitionName = 'slide-left'
        }
        this.$router.isBack = false
      },
    },
    methods: {
      setPopup() {
        const isAndroid =
          navigator.userAgent.indexOf('Android') > -1 ||
          navigator.userAgent.indexOf('Adr') > -1
        const u = navigator.userAgent
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
        this.originalHeight =
          document.documentElement.clientHeight || document.body.clientHeight
        if (!isiOS && !isAndroid) {
          document.querySelector('html').setAttribute('class', 'setHtml')
          this.isPc = true
        } else {
          document.querySelector('html').className = ''
          this.isPc = false
        }
        document.body.onresize = () => {
          if (document.documentElement.clientWidth > 600) {
            document.querySelector('html').setAttribute('class', 'setHtml')
            this.isPc = true
          } else {
            document.querySelector('html').className = ''
            this.isPc = false
          }
          if (isiOS) {
            return
          }
          if (!isAndroid) {
            return
          }
          const resizeHeight =
            document.documentElement.clientHeight || document.body.clientHeight
          if (resizeHeight - 0 < this.originalHeight - 0) {
            this.$nextTick(() => {
              this.isPopup = true
            })
          } else {
            this.$nextTick(() => {
              this.isPopup = false
            })
          }
        }
      },
    },
  }
</script>
<style lang="less">
  #app {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    // min-height: 100%;
    // height: -webkit-fill-available;
    // height: 100%;
    // overflow-x: hidden;
    // overflow-y: auto;
    // overflow: hidden;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    position: relative;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
  }
  .appPc {
    width: 375px;
    height: 600px !important;
    margin: 30px auto;
    background-color: #fff;
  }
  .pc-model {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .appContent {
    // flex: 1;
    // overflow-y: auto;
  }
  .router-transition {
    width: 100%;
    // height: 100%;
    min-height: 100vh;
    // min-height: -webkit-fill-available;
    // position: absolute;
    position: relative;
    transition: all 0.3s ease;
  }

  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(100%, 0);
    transform: translate(100%, 0);
  }

  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-100%, 0);
    transform: translate(-100% 0);
  }
</style>
